import http from '../http-common';
import { withRunParam } from './analysisRunOptions';

class CoherenceLabelService {
  /**
   * Get all labels for a given analysis source. Labels are per run (M2 contract 5): pass the
   * run being viewed, or omit it for the active run.
   * @param {'interview'|'manual_analysis'} sourceType
   * @param {number} sourceId
   * @param {string} scoreMode
   * @param {string|null} run - Optional run id (`?run=`); omitted -> active run
   */
  getLabels(sourceType, sourceId, scoreMode, run = null) {
    return http.get(`/coherence-labels/${sourceType}/${sourceId}`, {
      params: withRunParam({ scoreMode }, run),
    });
  }

  /**
   * Upsert a segment label. Pass is_incoherent=null to remove the label (toggle off).
   * @param {Object} payload
   * @param {'interview'|'manual_analysis'} payload.source_type
   * @param {number} payload.source_id
   * @param {string|null} payload.block_id - null for FN segments (no VP card)
   * @param {number|null} payload.segment_start_ms
   * @param {number|null} payload.segment_end_ms
   * @param {boolean|null} payload.is_incoherent - null removes the label
   * @param {string|null} [payload.run_id] - run being viewed; omitted -> active run
   */
  upsertLabel(payload) {
    return http.post('/coherence-labels', payload);
  }

  /**
   * Copy the labels of one run onto another run of the same source (only those whose block ids
   * / target refs exist in the target run). Resolves { copied, skipped }.
   * @param {{ source_type: string, source_id: number, from_run_id: string, to_run_id: string }} payload
   */
  rebase(payload) {
    return http.post('/coherence-labels/rebase', payload);
  }

  /**
   * Get evaluation metrics, optionally filtered by source
   * @param {{ sourceType?: string, sourceId?: number }} filters
   */
  getMetrics(filters = {}) {
    const params = {};
    if (filters.sourceType) params.sourceType = filters.sourceType;
    if (filters.sourceId) params.sourceId = filters.sourceId;
    if (filters.scoreMode) params.scoreMode = filters.scoreMode;
    return http.get('/coherence-labels/metrics', { params });
  }
}

export default new CoherenceLabelService();
